import React from 'react';
import { X, Users, Clock, Hash, UserCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TeamPreviewModal = ({ team, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50'>
      <div className='bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto'>
        <div className='p-4 sm:p-6 border-b flex justify-between items-start sm:items-center gap-2'>
          <div className='flex items-center gap-2 sm:gap-4'>
            <div className='bg-indigo-100 p-2 sm:p-3 rounded-full'>
              <Users className='w-5 h-5 sm:w-6 sm:h-6 text-indigo-600'/>
            </div>
            <div>
              <h2 className='text-xl sm:text-2xl font-bold text-gray-900'>{team.name}</h2>
              <p className='text-xs sm:text-sm text-gray-500'>
                {team.employees.length} {t("teams.count")}{team.employees.length !== 1 ? 's' : ''}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className='text-gray-500 hover:text-gray-700 transition-colors mt-1'
          >
            <X className='w-5 h-5 sm:w-6 sm:h-6'/>
          </button>
        </div>
        <div className='p-4 sm:p-6'>
          <div className='space-y-4 sm:space-y-6'>
            {team.employees.map((member, index) => (
              <div
                key={index}
                className='bg-gray-50 rounded-lg p-3 sm:p-4 border hover:shadow-sm transition-shadow'
              >
                <div className='flex items-start sm:items-center space-x-2 sm:space-x-4 mb-3 sm:mb-4'>
                  <UserCircle2 className='w-8 h-8 sm:w-12 sm:h-12 text-indigo-600 flex-shrink-0'/>
                  <div>
                    <h3 className='text-base sm:text-lg font-semibold text-gray-900'>{member.name}</h3>
                    <div className='flex items-center gap-1 sm:gap-2 text-gray-500 mt-1'>
                      <Hash className='w-3 h-3 sm:w-4 sm:h-4'/>
                      <span className='text-xs sm:text-sm'>{member.number}</span>
                    </div>
                  </div>
                </div>

                <div className='grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4'>
                  <div className='flex items-center gap-1 sm:gap-2'>
                    <Clock className='w-3 h-3 sm:w-4 sm:h-4 text-gray-500' />
                    <span className='text-xs sm:text-sm text-gray-600'>{t("teams.members.weeklyHours")}:</span>
                    <span className='text-xs sm:text-sm font-medium'>
                      {isNaN(member.wkl_wrk_load) 
                        ? member.wkl_Wrk_Load / 10 
                        : member.wkl_wrk_load / 10}h
                    </span>
                  </div>
                  <div className='flex items-center gap-1 sm:gap-2'>
                    <Clock className='w-3 h-3 sm:w-4 sm:h-4 text-gray-500'/>
                    <span className='text-xs sm:text-sm text-gray-600'>{t("teams.members.dailyHours")}:</span>
                    <span className='text-xs sm:text-sm font-medium'>{member.day_WI / 10}h'</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPreviewModal;